<template>
  <div class="modal-overlay" @click.self="$emit('close')">
    <div class="modal-container">
        <div v-if="loading" class="loading-state">
        <div class="spinner"></div>
        <p>Đang tải dữ liệu...</p>
      </div>
      <div class="modal-header">
        <h2>Tài khoản đã xóa</h2>
        <button class="btn-close" @click="$emit('close')">✕</button>
      </div>
      <div class="modal-body">
        <table class="table" v-if="users.length">
          <thead>
            <tr>
              <th>#</th>
              <th>Tên</th>
              <th>Email</th>
              <th>Username</th>
              <th>Ngày xóa</th>
              <th>Hành động</th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="(user, index) in users" :key="user.id">
              <td>{{ index + 1 }}</td>
              <td>{{ user.name }}</td>
              <td>{{ user.email }}</td>
              <td>@{{ user.username }}</td>
              <td>{{ formatDate(user.deleted_at) }}</td>
              <td>
                <button class="btn btn-restore" @click="handleRestore(user.id)">
                  Khôi phục
                </button>
              </td>
            </tr>
          </tbody>
        </table>

        <div v-else class="empty">Không có tài khoản nào bị xóa</div>
      </div>

      <!-- Footer -->
      <div class="modal-footer">
        <button class="btn btn-outline" @click="$emit('close')">Đóng</button>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref, onMounted } from "vue";
import { adminApi } from "@/services/api";
import { useToast } from "@/composables/useToast";

const emit = defineEmits(["close", "restored"]);

const users = ref([]);
const loading = ref(false);
const toast = useToast();
// format date
const formatDate = (date) => {
  if (!date) return "-";
  return new Date(date).toLocaleString();
};

// fetch trashed users
const fetchTrashedUsers = async () => {
  try {
    loading.value = true;
    const res = await adminApi.getTrashedUsers();
    users.value = res.data.data.data || res.data;
  } catch (err) {
    console.error(err);
  } finally {
    loading.value = false;
  }
};

const handleRestore = async (id) => {
  try {
    loading.value = true;
    await adminApi.restoreUser(id);
    users.value = users.value.filter((u) => u.id !== id);
    emit("restored");
    toast.success("Khôi phục tài khoản thành công");
  } catch (error) {
    const errorMessage = error.response?.data?.error || "Có lỗi xảy ra ";
    toast.error(errorMessage);
    console.error(error);
  }finally{
    loading.value = false;
  }
};

onMounted(fetchTrashedUsers);
</script>
<style scoped>

.btn-restore {
  background: #22c55e;
  color: white;
}

.btn-restore:hover {
  background: #16a34a;
}

/* empty */
.empty {
  text-align: center;
  color: #888;
  padding: 20px;
}
</style>
